import { useState } from "react";

const IntegerInput = ({ id, text, value, onChange, className = "", placeholder = "" }) => {
  const [errorRegex, setErrorRegex] = useState(false);

  const handleChange = (e) => {
    onChange(e);
    const newVal = e.target.value;
    const regex = /^\d*$/;

    setErrorRegex(!regex.test(newVal));
  };

  return (
    <div>
      <label htmlFor={id} className="text-gray-800">{text}</label>
      {errorRegex && <p className="text-sm text-red-500">*El valor debe ser un número entero</p>}
      <input
        type="text"
        id={id}
        name={id}
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        className={`
          block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900
          placeholder:text-gray-400 focus:outline-2 focus:outline-offset-2 focus:outline-indigo-600 sm:text-sm/6
          ${errorRegex ? "outline-red-500 outline-2" : "outline-gray-400 outline-1"}
          ${className}
        `}
      />
    </div>
  );
};

export default IntegerInput;
